export enum ButtonHtmlType {
  Submit = 'submit',
  Reset = 'reset',
  Button = 'button',
}
